export const FETCH_DISTRICT_LIST_REQUEST = 'FETCH_DISTRICT_LIST_REQUEST';
export const FETCH_DISTRICT_LIST_SUCCESS = 'FETCH_DISTRICT_LIST_SUCCESS';
export const FETCH_DISTRICT_LIST_FAILURE = 'FETCH_DISTRICT_LIST_FAILURE';
export const CLEAR_DISTRICT_LIST = 'CLEAR_DISTRICT_LIST';
